<template>
  <div class="card-management">
    <!-- 顶部操作栏 -->
    <div class="operation-bar">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-input
            v-model="queryForm.card_id"
            placeholder="请输入卡密"
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleSearch"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input
            v-model="queryForm.name"
            placeholder="请输入用户名"
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
          >
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="queryForm.card_type"
            placeholder="卡密类型"
            clearable
            @change="handleSearch"
          >
            <!-- 魔趣解析会员类型 -->
            <el-option-group label="魔趣解析会员">
              <el-option label="魔趣解析1天卡" value="basic_daily"></el-option>
              <el-option label="魔趣解析周卡" value="basic_weekly"></el-option>
              <el-option label="魔趣解析月卡" value="basic_monthly"></el-option>
              <el-option label="魔趣解析年卡" value="basic_yearly"></el-option>
              <el-option label="魔趣解析永久卡" value="basic_permanent"></el-option>
            </el-option-group>
            
            <!-- 全能会员类型 -->
            <el-option-group label="全能会员">
              <el-option label="全能1天卡" value="premium_daily"></el-option>
              <el-option label="全能周卡" value="premium_weekly"></el-option>
              <el-option label="全能月卡" value="premium_monthly"></el-option>
              <el-option label="全能年卡" value="premium_yearly"></el-option>
              <el-option label="全能永久卡" value="premium_permanent"></el-option>
            </el-option-group>
            <el-option-group label="升级卡">
              <el-option label="全能升级卡" value="upgrade_basic_to_premium"></el-option>
            </el-option-group>
            
            <!-- 兼容旧版本类型 -->
            <el-option-group label="兼容类型">
              <el-option label="1天卡" value="daily"></el-option>
              <el-option label="周卡" value="weekly"></el-option>
              <el-option label="月卡" value="monthly"></el-option>
              <el-option label="年卡" value="yearly"></el-option>
              <el-option label="永久卡" value="permanent"></el-option>
            </el-option-group>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select
            v-model="queryForm.is_used"
            placeholder="使用状态"
            clearable
            @change="handleSearch"
          >
            <el-option label="未使用" :value="0"></el-option>
            <el-option label="已使用" :value="1"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="showCreateDialog">新增卡密</el-button>
          <el-button
            type="danger"
            @click="handleBatchDelete"
            :disabled="selectedCards.length === 0"
            >批量删除</el-button
          >
        </el-col>
      </el-row>
    </div>

    <!-- 列表区域 -->
    <el-table
      :data="cardList"
      @selection-change="handleSelectionChange"
      v-loading="loading"
      border
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="card_id" label="卡密"></el-table-column>
      <el-table-column prop="card_type" label="卡密类型">
        <template slot-scope="scope">
          <el-tag :type="getCardTypeTag(scope.row.card_type)">{{
            getCardTypeLabel(scope.row.card_type)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="created" label="创建时间"></el-table-column>
      <el-table-column prop="used" label="使用状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.used ? 'info' : 'success'">
            {{ scope.row.used ? "已使用" : "未使用" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="使用人"></el-table-column>
      <el-table-column prop="used_time" label="使用时间"></el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      >
      </el-pagination>
    </div>

    <!-- 新增卡密对话框 -->
    <el-dialog title="新增卡密" :visible.sync="createDialogVisible" width="500px">
      <el-form
        :model="createForm"
        :rules="createRules"
        ref="createForm"
        label-width="100px"
      >
        <el-form-item label="卡密类型" prop="card_type">
          <el-select
            v-model="createForm.type"
            placeholder="请选择卡密类型"
            style="width: 100%"
          >
            <!-- 魔趣解析会员类型 -->
            <el-option-group label="魔趣解析会员">
              <el-option label="魔趣解析1天卡" value="basic_daily"></el-option>
              <el-option label="魔趣解析周卡" value="basic_weekly"></el-option>
              <el-option label="魔趣解析月卡" value="basic_monthly"></el-option>
              <el-option label="魔趣解析年卡" value="basic_yearly"></el-option>
              <el-option label="魔趣解析永久卡" value="basic_permanent"></el-option>
            </el-option-group>
            
            <!-- 全能会员类型 -->
            <el-option-group label="全能会员">
              <el-option label="全能1天卡" value="premium_daily"></el-option>
              <el-option label="全能周卡" value="premium_weekly"></el-option>
              <el-option label="全能月卡" value="premium_monthly"></el-option>
              <el-option label="全能年卡" value="premium_yearly"></el-option>
              <el-option label="全能永久卡" value="premium_permanent"></el-option>
            </el-option-group>
            <el-option-group label="升级卡">
              <el-option label="全能升级卡" value="upgrade_basic_to_premium"></el-option>
            </el-option-group>
            <!-- 兼容旧版本类型 -->
            <el-option-group label="兼容类型">
              <el-option label="1天卡" value="daily"></el-option>
              <el-option label="周卡" value="weekly"></el-option>
              <el-option label="月卡" value="monthly"></el-option>
              <el-option label="年卡" value="yearly"></el-option>
              <el-option label="永久卡" value="permanent"></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="卡密数量" prop="quantity">
          <el-input-number
            v-model="createForm.quantity"
            :min="1"
            :max="1000"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
      <el-input
        v-model="createForm.remark"
        type="textarea"
        :rows="2"
        placeholder="请输入备注信息"
      ></el-input>
    </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="createDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleCreate">确定</el-button>
      </div>
    </el-dialog>

    <!-- 新增成功展示卡密对话框 -->
    <el-dialog title="新增卡密成功" :visible.sync="resultDialogVisible" width="600px">
      <div class="card-result">
        <el-input type="textarea" :rows="10" v-model="generatedCards" readonly>
        </el-input>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="copyCards">一键复制</el-button>
        <el-button @click="resultDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCardList, addCard, deleteCard, batchDeleteCard} from "@/api/index";
export default {
  name: "CardManagement",
  data() {
    return {
      // 查询表单
      queryForm: {
        card_id: "",
        name: "",
        card_type: "",
        is_used: "",
      },
      // 创建表单
      createForm: {
        type: "",
        quantity: 1,
        remark: ""
      },
      // 创建表单校验规则
      createRules: {
        type: [{ required: true, message: "请选择卡密类型", trigger: "change" }],
        quantity: [{ required: true, message: "请输入卡密数量", trigger: "blur" }],
      },
      // 表格数据
      cardList: [],
      loading: false,
      selectedCards: [],
      // 分页信息
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      // 对话框显示控制
      createDialogVisible: false,
      resultDialogVisible: false,
      // 生成的卡密列表
      generatedCards: "",
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 获取数据
    async fetchData() {
      this.loading = true;
      try {
        const res = await getCardList({
          ...this.queryForm,
          page: this.page.current,
          pageSize: this.page.size,
        });
        this.cardList = res.data.data;
        this.page.total = res.data.pagination.totalItems;
      } catch (error) {
        this.$message.error("获取数据失败");
      }
      this.loading = false;
    },

    // 查询
    handleSearch() {
      this.page.current = 1;
      this.fetchData();
    },

    // 显示创建对话框
    showCreateDialog() {
      this.createForm = {
        type: "",
        quantity: 1,
        remark: ""
      };
      this.createDialogVisible = true;
    },

    // 创建卡密
    async handleCreate() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          try {
            const res = await addCard(this.createForm);
            this.generatedCards = res.data.cards.join("\n");
            this.createDialogVisible = false;
            this.resultDialogVisible = true;
            this.fetchData();
          } catch (error) {
            this.$message.error("创建失败");
          }
        }
      });
    },

    // 复制卡密
    copyCards() {
      const textarea = document.createElement("textarea");
      textarea.value = this.generatedCards;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success("复制成功");
    },

    // 表格选择
    handleSelectionChange(val) {
      this.selectedCards = val;
    },

    // 删除单个卡密
    handleDelete(row) {
      this.$confirm("确认删除该卡密?", "提示", {
        type: "warning",
      }).then(async () => {
        try {
          await deleteCard([row.card_id]);
          this.$message.success("删除成功");
          this.fetchData();
        } catch (error) {
          this.$message.error("删除失败");
        }
      });
    },

    // 批量删除
    handleBatchDelete() {
      this.$confirm(`确认删除选中的 ${this.selectedCards.length} 个卡密?`, "提示", {
        type: "warning",
      }).then(async () => {
        try {
          const cardIds = this.selectedCards.map((item) => item.card_id);
          await batchDeleteCard({cardIds});
          this.$message.success("删除成功");
          this.fetchData();
        } catch (error) {
          this.$message.error("删除失败");
        }
      });
    },

    // 分页相关方法
    handleSizeChange(val) {
      this.page.size = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.fetchData();
    },

    // 工具方法
    getCardTypeLabel(type) {
      const map = {
        // 兼容旧版本类型
        daily: "1天卡",
        weekly: "周卡",
        monthly: "月卡",
        yearly: "年卡",
        permanent: "永久卡",
        
        // 魔趣解析会员类型
        basic_daily: "魔趣解析1天卡",
        basic_weekly: "魔趣解析周卡",
        basic_monthly: "魔趣解析月卡",
        basic_yearly: "魔趣解析年卡",
        basic_permanent: "魔趣解析永久卡",
        
        // 全能会员类型
        premium_daily: "全能1天卡",
        premium_weekly: "全能周卡",
        premium_monthly: "全能月卡",
        premium_yearly: "全能年卡",
        premium_permanent: "全能永久卡",
        
        // 升级卡类型
        upgrade_basic_to_premium: "全能升级卡"
      };
      return map[type] || type;
    },
    getCardTypeTag(type) {
      const map = {
        // 兼容旧版本类型
        daily: "info",
        weekly: "info",
        monthly: "warning",
        yearly: "success",
        permanent: "danger",
        
        // 魔趣解析会员类型 - 使用蓝色系
        basic_daily: "primary",
        basic_weekly: "primary",
        basic_monthly: "primary",
        basic_yearly: "primary",
        basic_permanent: "primary",
        
        // 全能会员类型 - 使用金色/橙色系
        premium_daily: "warning",
        premium_weekly: "warning",
        premium_monthly: "warning",
        premium_yearly: "success",
        premium_permanent: "danger",
        
        // 升级卡类型 - 使用特殊颜色
        upgrade_basic_to_premium: "success"
      };
      return map[type] || "";
    },
  },
};
</script>

<style scoped>
.card-management {
  padding: 20px;
}

.operation-bar {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.pagination-container {
  text-align: right;
  margin-top: 20px;
}

.card-result {
  margin: 10px 0;
}

.el-tag {
  text-transform: capitalize;
}

.el-select {
  width: 100%;
}

.el-button + .el-button {
  margin-left: 10px;
}
</style>